<template>
  <el-dialog
    v-if="visible"
    :visible="true"
    title="传感器详情"
    width="90%"
    top="5vh"
    :before-close="sensorClose"
  >
    <div class="graphic-data-wrap">
      <div class="action">
        <el-button @click="clearBground">清除本底</el-button>
      </div>
      <el-tabs v-model="active">
        <el-tab-pane
          v-for="(item, index) in tabs"
          :key="item.mod"
          :label="item.label"
          :name="item.mod"
        >
          <ChartsContent
            v-if="item.mod === active"
            :color="chartColors[index]"
            :data="dataMap[item.mod]"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { tabs, chartColors } from './utils';
import ChartsContent from './components/content.vue';
import { clearBground } from '@/api/devices';

export default {
  components: {
    ChartsContent
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sn: {
      type: String,
      default: ''
    },
    first: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    },
    hisData: {
      type: [Array, null],
      default: null
    }
  },
  data() {
    return {
      active: '',
      chartColors,
      dataMap: {
        cwaMod: {},
        tvocMod: {},
        smokeMod: {}
      }
    };
  },
  computed: {
    ...mapState('socket', ['subDeviceMap']),
    data() {
      if (Array.isArray(this.hisData)) return this.hisData[this.hisData.length - 1];
      const data = this.subDeviceMap[this.sn];
      if (!data) return null;
      return data;
    },
    mods() {
      const data = this.data;
      if (data && data.mods) return data.mods;
      return null;
    },
    tabs() {
      if (!this.mods) return [];
      const keys = Object.keys(this.mods);
      return tabs.filter(e => keys.includes(e.mod));
    }
  },
  methods: {
    /** 初始化参数 */
    initialise(n) {
      if (!n) return;
      this.$nextTick(() => {
        if (!this.tabs.length) return;
        this.active = this.first || this.tabs[0].mod;
      });
    },
    /** 关闭对话框 */
    sensorClose() {
      this.$emit('update:visible', false);
    },
    /** 本底清除 */
    clearBground() {
      clearBground({ sn: this.sn, deviceType: this.deviceType }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '清除成功'
          });
        }
      });
    },
    /** 更新所有图表数据 */
    updateChartData(n) {
      /** @type {{ beginTime:number, mods: { [index:string]: { sensors: { [index:string]: string|number } }}}} */
      const { beginTime, mods } = n;
      /** 模块名 */
      const keys = Object.keys(mods);
      /** 接收数据中传感器临时变量 */
      let sensors = null;
      /** this.dataMap 模块临时变量 */
      let mod = null;
      /**
       * 本地数据传感器临时变量
       * @type {{ name: string, unit: string, data: [number, number][] }}
       */
      let temp = null;
      keys.forEach(key => {
        sensors = (mods[key] || {}).sensors;
        if (!sensors) return;
        mod = this.dataMap[key] = this.dataMap[key] || {};
        sensors.forEach(e => {
          temp = mod[e.name] = mod[e.name] || {};
          temp.name = e.name;
          temp.unit = e.unitName;
          temp.data = temp.data || [];
          temp.data.push([beginTime, e.value]);
          if (temp.data.length > 15 && !Array.isArray(this.hisData)) temp.data.shift();
        });
      });
    },
    updateHisData() {
      if (Array.isArray(this.hisData)) {
        this.hisData.forEach(e => {
          this.updateChartData(e);
        });
      }
    }
  },
  watch: {
    visible: 'initialise',
    data: 'updateChartData',
    hisData: 'updateHisData'
  }
};
</script>

<style lang="scss"></style>
